export const scrollToFirstError = () => {
  setTimeout(() => {
    const firstErrorElement = document.querySelector('.ant-form-item-has-error');
    firstErrorElement?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, 10);
}

export default null;
